import { useI18n } from "../i18n/I18nContext";
import { useSiteContent } from "../context/SiteContentContext";

export default function Story() {
  const { t, lang } = useI18n();
  const { content } = useSiteContent();
  const c = (key) => content[key]?.[lang] || content[key]?.en || "";
  return (
    <main className="max-w-[1200px] mx-auto px-6 md:px-12 pt-16 pb-24" data-testid="story-page">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-24 fade-in">
          <div className="label-caps text-muted-foreground mb-4">{t("nav.story")}</div>
          <h1 className="font-hand text-6xl md:text-7xl leading-tight mb-8">
            {c("story_title")}
          </h1>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed whitespace-pre-line">
            {c("story_body")}
          </p>
        </div>
        <div className="lg:col-span-7 space-y-6 fade-in" style={{ animationDelay: "150ms" }}>
          <div className="product-image-wrap aspect-[4/5]">
            <img src="https://customer-assets-7cd3h4nn.emergentagent.net/job_ceramic-shop-18/artifacts/hntemrqm_Pikkurumiluksia2.webp" alt="Studio" className="w-full h-full object-cover" />
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="product-image-wrap aspect-square">
              <img src="https://customer-assets-7cd3h4nn.emergentagent.net/job_ceramic-shop-18/artifacts/bmiubr78_Pikkrumiluksia3.webp" alt="Bunnies" className="w-full h-full object-cover" />
            </div>
            <div className="product-image-wrap aspect-square">
              <img src="https://customer-assets-7cd3h4nn.emergentagent.net/job_ceramic-shop-18/artifacts/cdcx3yai_Pikkurumiluksia4.webp" alt="Stack" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
